export enum EMainMenuCounters {
	PROFILE = 10212,
	FEED = 7935,
	FRIENDS = 7934,
	VIDEO = 2527252,
	MUSIC = 2920804,
	COMMUNITIES = 77828287,
	GAMES_CATALOG = 7940,

	BALANCE = 77828284,
	FULL_VERSION = 1920853,

	LOGOUT = 74149691,
	LOGIN = 74149690,
	REGISTRATION = 74149692,
}
